// Périodes comptables pour les exports CSV
export const PERIOD_OPTIONS = [
  { value: "all", label: "Tout l'historique" },
  { value: "this_month", label: "Ce mois-ci" },
  { value: "last_month", label: "Mois dernier" },
  { value: "this_quarter", label: "Trimestre en cours" },
  { value: "last_quarter", label: "Trimestre précédent" },
  { value: "this_year", label: "Année en cours" },
];

export function periodRange(period) {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const iso = (d) => d.toISOString().slice(0, 10);
  switch (period) {
    case "this_month":
      return [iso(new Date(Date.UTC(y, m, 1))), iso(now)];
    case "last_month":
      return [iso(new Date(Date.UTC(y, m - 1, 1))), iso(new Date(Date.UTC(y, m, 0)))];
    case "this_quarter": {
      const q = Math.floor(m / 3) * 3;
      return [iso(new Date(Date.UTC(y, q, 1))), iso(now)];
    }
    case "last_quarter": {
      const q = Math.floor(m / 3) * 3;
      return [iso(new Date(Date.UTC(y, q - 3, 1))), iso(new Date(Date.UTC(y, q, 0)))];
    }
    case "this_year":
      return [`${y}-01-01`, iso(now)];
    default:
      return [null, null];
  }
}

export function exportQuery(period) {
  const [start, end] = periodRange(period);
  return start ? `?start=${start}&end=${end}` : "";
}
